import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import logo from "../../public/ccr-logo-sm.png";

type Size = "sm" | "md" | "lg";

interface Props {
	href?: string;
	size?: Size;
}

const getTwSize = (size: Size): string => {
	switch (size) {
		case "sm":
			return "w-28 md:w-24";
		case "lg":
			return "w-44 md:w-64";
		default:
			return "w-28 md:w-28";
	}
};

const Logo = ({ href, size = "md" }: Props) => {
	const { t } = useTranslation();
	const cls = `inline-block ${getTwSize(size)}`;

	return href ? (
		<Link to={href} title={t("common.app_name")} className={cls}>
			<img src={logo} alt="CCR Logo" />
		</Link>
	) : (
		<span className={cls}>
			<img src={logo} alt="CCR Logo" />
		</span>
	);
};

export default Logo;
